import { z } from 'src/lib'
import { OperacionWRMFields, getEndpoint } from '.'
import { EntityWithIdFields } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z
    .object({
        [OperacionWRMFields.CodOperacion]: z.number(),
        [OperacionWRMFields.CodPais]: z.number(),
        [OperacionWRMFields.CodSectorComercial]: z.number(),
        [OperacionWRMFields.FechaEmision]: z.coerce.date(),
        [OperacionWRMFields.FechaVencimiento]: z.coerce.date(),
        [OperacionWRMFields.IdUsuarioAlta]: z.number(),
        [OperacionWRMFields.NombreUsuarioAlta]: z.string(),
        [OperacionWRMFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionWRMFields.MailUsuarioAlta]: z.string(),
        [OperacionWRMFields.NombrePais]: z.string(),
        [OperacionWRMFields.NombreSectorComercial]: z.string().nullable(),
        [OperacionWRMFields.Observaciones]: z.string().optional(),
        [OperacionWRMFields.PermiteEditar]: z.boolean(),
        [OperacionWRMFields.PermiteEliminar]: z.boolean()
    })
    .extend({
        [EntityWithIdFields.Id]: z.number()
    })

export type OperacionWRM = z.infer<typeof schema>

export const get = (idOperacion: number): Promise<OperacionWRM> => {
    const endpoint = getEndpoint(`${idOperacion}`)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error('Error de validación:', parsed.error.issues)

                return Promise.reject(new Error('Error de validación.'))
            }

            return parsed.data
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
